import useAffiliateCode from '@/hooks/use-affiliate-code';
import {
  Outlet,
  createFileRoute,
  redirect,
  useSearch,
} from '@tanstack/react-router';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

export const Route = createFileRoute('/(unathenticated)/auth/_layout')({
  beforeLoad: async ({ context }) => {
    if (context.auth.isAuthenticated && !context.auth.loading) {
      const searchParams = new URLSearchParams(location.search);
      const redirectPath = searchParams.get('redirect');
      throw redirect({
        to: redirectPath ?? '/dashboard/home',
      });
    }
  },
  component: LayoutComponent,
  validateSearch: (search: Record<string, unknown>): { network?: string } => {
    return {
      network: search.network ? String(search.network) : undefined,
    };
  },
});

//Auth Layout - generic
function LayoutComponent(): JSX.Element {
  useAffiliateCode();
  const [_, setNetworkCookie] = useCookies(['network_type']);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- useSearch returns unknown, so we assert the type for type safety
  const search = useSearch('network') as { network?: string };

  useEffect(() => {
    if (search.network) {
      let cookieValue = 'MLM';

      if (String(search.network) === '2') {
        cookieValue = 'AFFILIATE';
      }

      setNetworkCookie('network_type', cookieValue, { path: '/' });
    }
  }, [search.network, setNetworkCookie]);

  return (
    <div className="dark">
      <Outlet />
    </div>
  );
}
